<template>
  <empty-layout>
    <div
      class="w-full h-full flex flex-col justify-center text-black font-proxima-nova"
      :class="isIos() ? 'pt-[60px]' : ''"
    >
      <div class="mx-auto w-[327px] md:w-[702px]">
        <div
          class="cursor-pointer w-max flex gap-2 my-6 ml-auto"
          @click="logoutUser"
        >
          <img
            class="w-[24px] h-[24px]"
            src="/assets/icons/logout-black.svg"
            alt="Log Out"
          />
          <p class="text-[16px] font-[400] leading-[20px] font-aktiv-grotesk">
            Log Out
          </p>
        </div>
      </div>
      <div v-html="accessDenied.htmlPage"></div>
    </div>
  </empty-layout>
</template>

<script>
import { Browser } from "@capacitor/browser";
import { useAuth0 } from "@auth0/auth0-vue";
import EmptyLayout from "@/components/EmptyLayout.vue";
import { isIosNativeOnly } from "@/utils/platform-check";
import { createLogoutUri } from "@/utils/redirect-uri";
export default {
  components: { EmptyLayout },
  name: "access-denied",
  data() {
    const { logout } = useAuth0();
    return {
      logout: logout,
      accessDenied: {
        htmlPage: `
          <div class="mt-[20px] mb-[42px] md:mt-[48px] md:mb-[88px] lg:w-[854px] lg:max-w-[854px] flex flex-col items-center mx-auto">
            <img class="w-[282px] md:w-[307px] lg:w-[335px]" src="/assets/images/hogc-sg-logo.svg" alt="HOGC SG">
            <div class="font-caveat font-bold text-center text-[36px] md:text-[44px] leading-[40px] md:leading-[44px] tracking-[-1%] mt-[24px] md:mt-[44px]">
              Hello There! <br class="md:hidden">
              Tried signing in?
            </div>
            <div class="relative">
              <p class="relative mt-[24px] md:mt-[32px] w-[327px] md:w-[702px] text-center text-[20px] leading-[24px] md:text-[24px] md:leading-[32px]">
                We noticed you're using a <br>
                <span class="font-bold">GenerationS Pastors Conference App account</span> to log in. 
              </p>
              <p class="relative mt-[24px] md:mt-[32px] w-[327px] md:w-[702px] text-center text-[20px] leading-[24px] md:text-[24px] md:leading-[32px]">
                This portal is for GenerationS Implementation Community (Europe).
              </p>
            </div>
            <p class="mt-[20px] text-center text-[16px] leading-[24px] w-[327px] md:mt-[28px] md:text-[20px] md:w-[600px] lg:mt-[32px] lg:w-[854px]">
              Have a question?
              <a
                class="text-lightblue font-bold underline"
                target="_blank"
                href="mailto:gic@generationsmvmt.com?subject=Enquiry%20Regarding%20GenerationS%20Implementation%20Community%20(Europe)"
              >
                Contact us and let us know.</a
              >
            </p>
          </div>
`,
      },
    };
  },
  async ionViewDidEnter() {
    // TODO refactor this to be in CMS when move to mobile app
    // await this.fetchCVP()
  },
  methods: {
    isIos() {
      return isIosNativeOnly();
    },
    // async fetchCVP() {
    //   const { data } = await axios.get(
    //     process.env.VUE_APP_API_URL + "/cms/access-denied-page",
    //   );
    //   // console.log("DATA", data);
    //   this.accessDenied = data;
    //   // console.log("CVPOBJ: ", this.cvpObj);
    // },
    // duplicate from logoutPopup
    async logoutUser() {
      if (process.env.VUE_APP_NODE_ENV === "local") {
        localStorage.removeItem("token");
        this.$router.push("/login");
      } else {
        await this.logout({
          logoutParams: {
            returnTo: createLogoutUri(
              process.env.VUE_APP_PACKAGE_ID,
              process.env.VUE_APP_AUTH0_DOMAIN
            ),
          },
          openUrl: async (url) =>
            await Browser.open({
              url,
              windowName: "_self",
            }),
        });
      }
    },
  },
};
</script>

<style scope></style>
